import { KOREAN } from '@/app/app.config'
import { z } from 'zod'

const defaultMessage = KOREAN ? '필수 입력 항목입니다' : 'This field is required.'

export const passwordPattern =
  // /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/
  /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*?_]).{8,16}$/

export function zStringRequired(message = defaultMessage) {
  return z.string({ required_error: message }).min(1, { message })
}

export function zInfoIdOptional() {
  return z.number().optional().or(z.literal(''))
}

export function zInfoIdRequired(message = defaultMessage) {
  return z
    .number({ required_error: message, invalid_type_error: message })
    .or(z.literal(''))
    .refine(id => id && id > 0, { message })
}

export function zInfo(message = defaultMessage) {
  return z.object(
    { id: z.number().or(z.string()), value: z.string(), valueEnglish: z.string().optional() },
    { invalid_type_error: message }
  )
}

export function zInfos(message = defaultMessage) {
  return zInfo(message).array()
}

export function zInfosRequired(message = defaultMessage) {
  return zInfos(message).min(1, message)
}

export const TelRegex =
  /^(?:02\d{3,4}\d{4}|0504\d{3}\d{4}|0505\d{3}\d{4}|0\d{1,2}\d{3,4}\d{4}|1[0-9]{3}\d{4})$/

export const validateTel = (str: string) => {
  // 숫자만 추출
  const numericOnly = str.replace(/[^0-9]/g, '')

  // 길이 검증
  if (numericOnly.length < 8 || numericOnly.length > 11) {
    return false
  }

  // 패턴 검증
  return TelRegex.test(numericOnly)
}

/** 카드번호 정규식(숫자와 자리수만 체크) */
export const CardNumberRegex = /^[0-9]{14,16}$/
